import useFeatureFlags from '@hooks/useFeatureFlags';
import featureFlagManagerForInitialization from '@service/initializationFeatureFlags';
import { useEffect } from 'react';

const FeatureFlagInitializer = () => {
  const { features } = useFeatureFlags();
  const isKeycloakLoginWithSso = features.isKeycloakLoginWithSso();
  const isAgencyMarketingKrakendEnable =
    features.isAgencyMarketingKrakendEnable();

  useEffect(() => {
    featureFlagManagerForInitialization.setIsKeycloakLoginWithSso(
      isKeycloakLoginWithSso,
    );
  }, [isKeycloakLoginWithSso]);

  useEffect(() => {
    featureFlagManagerForInitialization.setIsAgencyMarketingKrakendEnable(
      isAgencyMarketingKrakendEnable,
    );
  }, [isAgencyMarketingKrakendEnable]);

  return null;
};

export default FeatureFlagInitializer;
